export const WHATSAPP_NUMBER = '541166371898';

export const SERVICE_MESSAGES = {
    'Administración de Pagos': 'Hola, me gustaría consultar sobre Administración de Pagos. ¿Podrían ayudarme?',
    'Reimpresión de Facturas': 'Hola, necesito información sobre Reimpresión de Facturas. ¿Cómo puedo solicitarlo?',
    'Pago de Expensas': 'Hola, tengo una consulta sobre Pago de Expensas. ¿Podrían asistirme?',
    'Planes Municipales': 'Hola, me interesa conocer más sobre Planes Municipales. ¿Tienen disponibilidad?',
    'Planes ARBA': 'Hola, necesito información sobre Planes ARBA. ¿Cómo funciona el servicio?',
    'Pagos AGIP': 'Hola, tengo una consulta sobre Pagos AGIP. ¿Podrían ayudarme?',
    'Servicios Públicos': 'Hola, me gustaría consultar sobre Servicios Públicos (EDEA, OSSE, AySA). ¿Cómo funciona?',
    'Gestoría del Automotor': 'Hola, necesito información sobre Gestoría del Automotor. ¿Qué trámites realizan?',
    'Trámites en Registro de la Propiedad Inmueble': 'Hola, me gustaría consultar sobre trámites en el Registro de la Propiedad Inmueble. ¿Podrían ayudarme?',
    'Solicitud de Partidas': 'Hola, necesito información sobre Solicitud de Partidas. ¿Cómo puedo tramitarlas?'
};

export const getServiceWhatsAppUrl = (serviceName) => {
    const message = SERVICE_MESSAGES[serviceName]
        || `Hola, me gustaría consultar sobre ${serviceName}. ¿Podrían ayudarme?`;
    return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
};

export const getGeneralInquiryWhatsAppUrl = () => {
    const message = 'Hola, no encontré lo que buscaba en la web. Quisiera hacer una consulta.';
    return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
};

export const openServiceWhatsApp = (serviceName) => {
    window.open(getServiceWhatsAppUrl(serviceName), '_blank', 'noopener,noreferrer');
};

export const openGeneralInquiryWhatsApp = () => {
    window.open(getGeneralInquiryWhatsAppUrl(), '_blank', 'noopener,noreferrer');
};

export const attachLandingInteractions = (root, signal) => {
    if (!root) return;

    const scope = root.querySelector('.landing-container') || root;

    scope.querySelectorAll('.feature-card').forEach((card) => {
        const serviceName = card.getAttribute('data-service')
            || card.querySelector('h3')?.textContent?.trim();

        if (!serviceName) return;

        card.style.cursor = 'pointer';
        card.addEventListener('click', () => openServiceWhatsApp(serviceName), { signal });
    });

    scope.querySelectorAll('button.btn-inquiry').forEach((button) => {
        button.addEventListener('click', (event) => {
            event.preventDefault();
            openGeneralInquiryWhatsApp();
        }, { signal });
    });
};
